// extracted by mini-css-extract-plugin
export default {"container":"QRCode_container__zjh4m","qr":"QRCode_qr__AwyOs"};